import React from 'react';
import styled from 'styled-components';

interface ActionButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    isActive?: boolean;
    fullWidth?: boolean;
    variant?: 'primary' | 'secondary';
}

export const ActionButton: React.FC<ActionButtonProps> = ({ 
    children, 
    onClick, 
    isActive = true,
    fullWidth = false,
    variant = 'primary'
}) => {
    return (
        <Button 
            onClick={onClick} 
            $isActive={isActive}
            $fullWidth={fullWidth}
            $variant={variant}
        >
            {children}
        </Button>
    );
};

const Button = styled.button<{ 
    $isActive: boolean; 
    $fullWidth: boolean;
    $variant: 'primary' | 'secondary';
}>`
    border-radius: 100px;
    border: ${props => props.$variant === 'secondary' ? '1px solid #A4A4A4' : 'none'};
    background: ${props => {
        if (props.$variant === 'secondary') return 'white';
        return props.$isActive ? '#6777FF' : '#A8B3FF';
    }};
    color: ${props => props.$variant === 'secondary' ? '#00000080' : 'white'};
    font-size: 13px;
    font-weight: 600;
    cursor: ${props => props.$isActive ? 'pointer' : 'not-allowed'};
    transition: all 0.2s ease;
    opacity: ${props => props.$isActive ? '1' : '0.7'};
    font-family: SF Pro Display;
    
    &:hover {
        background: ${props => {
            if (props.$variant === 'secondary') return '#f5f5f5';
            return props.$isActive ? '#5566ee' : '#A8B3FF';
        }};
    }

    &:active {
        transform: ${props => props.$isActive ? 'scale(0.98)' : 'none'};
    }
`;
